import { pathname } from '../../utils';
import OnboardingEightFigExplanation from '../../pages/onboarding/8fig-explanation';
import OnboardingSellerId from '../../pages/onboarding/company/seller-id/sellerId';
import OnboardingStoreUrl from '../../pages/onboarding/company/storeUrl';
import OnboardingCompanyName from '../../pages/onboarding/company/companyName';
import OnboardingLineExplained from '../../pages/onboarding/lines/lineExplanation';
import OnboardingProduct from '../../pages/onboarding/product/product-picker/product';
import OnboardingProductUrl from '../../pages/onboarding/product/url';
import OnboardingProductName from '../../pages/onboarding/product/name';
import OnboardingProductNumShipments from '../../pages/onboarding/product/numShipments';
import OnboardingProductNextBatch from '../../pages/onboarding/product/nextBatch';
import OnboardingProductPrice from '../../pages/onboarding/product/price';
import OnboardingCreateLine from '../../pages/onboarding/lines/createLine';
import OnboardingMobileReviewLines from '../../pages/onboarding/mobile/mobileReviewLines';
import OnboardingMobileSubmitApp from '../../pages/onboarding/mobile/mobileSubmitApp';

export const onboardingPages = [
  {
    component: OnboardingEightFigExplanation,
    path: pathname.onboarding.main.eightFigExplanation.url,
  },
  {
    component: OnboardingSellerId,
    path: pathname.onboarding.main.sellerId.url,
  },
  {
    component: OnboardingStoreUrl,
    path: pathname.onboarding.extras.storeUrl.url,
  },
  {
    component: OnboardingCompanyName,
    path: pathname.onboarding.extras.companyName.url,
  },
  {
    component: OnboardingLineExplained,
    path: pathname.onboarding.main.lineExplained.url,
  },

  {
    component: OnboardingProduct,
    path: pathname.onboarding.main.product.url,
  },
  {
    component: OnboardingProductUrl,
    path: pathname.onboarding.extras.productUrl.url,
  },
  {
    component: OnboardingProductName,
    path: pathname.onboarding.main.productName.url,
  },
  {
    component: OnboardingProductNumShipments,
    path: pathname.onboarding.main.productNumShipments.url,
  },
  {
    component: OnboardingProductNextBatch,
    path: pathname.onboarding.main.productNextBatch.url,
  },
  {
    component: OnboardingProductPrice,
    path: pathname.onboarding.main.productPrice.url,
  },
  {
    component: OnboardingCreateLine,
    path: pathname.onboarding.main.createFirstLine.url,
  },
  {
    component: OnboardingMobileReviewLines,
    path: pathname.onboarding.main.mobileReviewLines.url,
  },
  {
    component: OnboardingMobileSubmitApp,
    path: pathname.onboarding.main.mobileSubmitApp.url,
  },
];
